import ICarLoanOrder from "./ICarLoanOrder";
import IRequiredDocumentDetail from "@/module/main/dto/IRequiredDocumentDetail";

export class CarLoanOrder implements ICarLoanOrder
{
    constructor(
        public requiredDocuments: IRequiredDocumentDetail[]
    )
    {
    }
}
